import Link from 'next/link'
import { memo } from 'react'

import { AcsCatBlockProps } from '../../types'
import { AccordionText } from '../AccordionText/AccordionText'

import cl from './AcsNavItem.module.scss'

export const AcsNavItem = memo(({ CATEGORIES }: AcsCatBlockProps): JSX.Element => {
	const currentData = CATEGORIES.filter(item => item.COUNT)
	return (
		<ul className={cl.list}>
			{CATEGORIES &&
				currentData.slice(0, 4).map((item, index) => (
					<li className={cl.item} key={index}>
						<Link prefetch={false} href={`${item.LINK}`} className={cl.link}>
							{item.NAME}
						</Link>
					</li>
				))}
			{CATEGORIES.length > 4 && (
				<AccordionText className={cl.list}>
					{CATEGORIES &&
						currentData.slice(4).map((item, index) => (
							<li className={cl.item} key={index}>
								<Link prefetch={false} href={`${item.LINK}`} className={cl.link}>
									{item.NAME}
								</Link>
							</li>
						))}
				</AccordionText>
			)}
		</ul>
	)
})
